export default __webpack_public_path__ + "static/media/service-anytime.76333ce9.svg";